import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';

const OMS_URL = `${process.env.REACT_APP_API_OMS_URL}`;

interface IState {
  maintenance: boolean;
  loading: boolean;
}

const initialState: IState = {
  maintenance: true,
  loading: false,
};

export const maintenanceList = createAsyncThunk('maintenance/list', async (params: any, { rejectWithValue }: any) => {
  try {
    const res = await axios.get<any>(`${OMS_URL}/maintenance`);
    return res.data;
  } catch (error: any) {
    return rejectWithValue(error?.response);
  }
});

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    //
    builder.addCase(maintenanceList.pending, (state, action) => {
      // state.loading = true;
    });
    builder.addCase(maintenanceList.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(maintenanceList.rejected, (state, action: any) => {
      if (action.payload.status === 503) state.maintenance = false;
      // state.loading = false;
    });
  },
});
export default maintenanceSlice.reducer;
